// extracted by mini-css-extract-plugin
module.exports = {"pdpAlert":"previousPurchaseBlock_pdpAlert__jcu4Q","productPurchaseHistoryLink":"previousPurchaseBlock_productPurchaseHistoryLink__rLn5y"};